<template>
  <v-row>
    <v-row>
      <v-col class="align-left">
        <ExpandCollapseToggle
          id="nstmFatiguePanelToggle"
          @toggleAllPanels="toggleAllPanels"
          styleClass="mt-3"
          :panel="panels"
        />
      </v-col>
      <v-col class="align-right mt-2">
        <ValidationCountsHeader v-if="moduleType == MODULE_TYPES.MANAGEMENT" />
      </v-col>
    </v-row>
    <v-expansion-panels v-model="panels" multiple color="#fff">
      <v-expansion-panel value="nstmConditions" class="mt-5">
        <v-expansion-panel-title
          class="d-flex justify-start"
          hide-actions
          expand-icon="fa-solid fa-plus"
          collapse-icon="fa-solid fa-minus"
        >
          <v-icon v-if="panels.includes('nstmConditions')" icon="fa-solid fa-minus" />
          <v-icon v-else icon="fa-solid fa-plus" />
          <h3>NSTM Conditions</h3>
        </v-expansion-panel-title>
        <v-expansion-panel-text eager>
          <v-form v-model="validNSTMInspectionCondition" ref="nstmConditionForm">
            <LabelSelect
              labelXl="3"
              labelLg="4"
              labelMd="5"
              labelSm="6"
              selectXl="3"
              selectLg="4"
              selectMd="4"
              selectSm="5"
              id="nstmCondition"
              label="B.C.14 NSTM Inspection Condition"
              :refTable="REFERENCE_TABLE.CONDITION_RATING"
              :isEditable="isEditable"
              isRequired
              v-model="nstmInspectionCondition"
              @update:modelValue="inspectionStore.setNstmInspectionConditionChangedByUser(true)"
            ></LabelSelect></v-form
        ></v-expansion-panel-text>
      </v-expansion-panel>
      <v-expansion-panel value="generalInformation">
        <v-expansion-panel-title
          class="d-flex justify-start"
          hide-actions
          expand-icon="fa-solid fa-plus"
          collapse-icon="fa-solid fa-minus"
        >
          <v-icon v-if="panels.includes('generalInformation')" icon="fa-solid fa-minus" />
          <v-icon v-else icon="fa-solid fa-plus" />
          <h3>General Information</h3>
        </v-expansion-panel-title>
        <v-expansion-panel-text eager>
          <v-row>
            <v-col class="px-0 pt-3">
              <v-row class="pb-2">
                <v-col cols="6" class="px-4">
                  <h3 class="withBackground alignCenter mb-2">Plug Weld Indicator</h3>
                  <v-row>
                    <v-col class="ml-3">
                      <LabelSelect
                        labelXl="6"
                        labelLg="7"
                        labelMd="7"
                        labelSm="7"
                        selectXl="6"
                        selectLg="5"
                        selectMd="5"
                        selectSm="5"
                        id="superStructure"
                        label="NF.01 Superstructure"
                        :isEditable="isEditable && isManagement"
                        :refTable="REFERENCE_TABLE.PLUG_WELD_PROBLEM_TYPE"
                        v-model="superStructure"
                      ></LabelSelect>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col class="ml-3">
                      <LabelSelect
                        labelXl="6"
                        labelLg="7"
                        labelMd="7"
                        labelSm="7"
                        selectXl="6"
                        selectLg="5"
                        selectMd="5"
                        selectSm="5"
                        id="substructure"
                        label="NF.02 Substructure"
                        :isEditable="isEditable && isManagement"
                        :refTable="REFERENCE_TABLE.PLUG_WELD_PROBLEM_TYPE"
                        v-model="subStructure"
                      ></LabelSelect>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="6" class="px-4">
                  <h3 class="withBackground alignCenter mb-2">Estimated Truck Traffic</h3>
                  <v-row>
                    <v-col class="ml-3">
                      <LabelText
                        labelXl="9"
                        labelLg="10"
                        labelMd="10"
                        labelSm="10"
                        textXl="3"
                        textLg="2"
                        textMd="2"
                        textSm="2"
                        id="cumlativeTruckTraffic"
                        label="NF.03 Cumulative Truck Traffic"
                        type="number"
                        maxlength="9"
                        :isEditable="isEditable && isManagement"
                        v-model="estimatedTruckTraffic"
                      ></LabelText>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col class="ml-3">
                      <LabelText
                        labelXl="9"
                        labelLg="10"
                        labelMd="10"
                        labelSm="10"
                        textXl="3"
                        textLg="2"
                        textMd="2"
                        textSm="2"
                        id="cumulativeTruckTrafficforFatigueDamage"
                        :isEditable="isEditable && isManagement"
                        label="NF.04 Cumulative Truck Traffic for Fatigue Damage"
                        type="number"
                        maxlength="6"
                        v-model="cumulativeTruckTrafficforFatigueDamage"
                      ></LabelText>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col class="ml-3">
                      <LabelText
                        labelXl="9"
                        labelLg="10"
                        labelMd="10"
                        labelSm="10"
                        textXl="3"
                        textLg="2"
                        textMd="2"
                        textSm="2"
                        id="yearOfEstimate"
                        label="NF.05 Year of Estimate"
                        type="number"
                        maxlength="4"
                        :showComma="false"
                        :rules="
                          isEditable && estimatedTruckYear
                            ? [
                                (value) => {
                                  return valueInLimitsRule(value, 1111, 9999);
                                },
                              ]
                            : []
                        "
                        :isEditable="isEditable && isManagement"
                        v-model="estimatedTruckYear"
                      ></LabelText>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-expansion-panel-text>
      </v-expansion-panel>
      <v-expansion-panel value="nstmDetails">
        <v-expansion-panel-title
          class="d-flex justify-start"
          hide-actions
          expand-icon="fa-solid fa-plus"
          collapse-icon="fa-solid fa-minus"
        >
          <v-icon v-if="panels.includes('nstmDetails')" icon="fa-solid fa-minus" />
          <v-icon v-else icon="fa-solid fa-plus" />
          <h3>NSTM Details</h3>
        </v-expansion-panel-title>
        <v-expansion-panel-text eager>
          <v-data-table
            v-if="moduleType == MODULE_TYPES.INSPECTION"
            class="noScrollTable compactTable"
            :items-per-page="-1"
            :headers="headers"
            :items="spanSets"
            return-object
            hide-default-footer
          >
            <template v-slot:[`header.spanConfigDesignation`]="{ column }">
              <DataTableHeader :column="column" :lines="2" />
            </template>
            <template v-slot:[`header.mainSpanSetIndicator`]="{ column }">
              <DataTableHeader :column="column" :lines="2" />
            </template>
            <template v-slot:[`header.spanMaterial`]="{ column }">
              <DataTableHeader :column="column" :lines="2" />
            </template>
            <template v-slot:[`header.spanContinuity`]="{ column }">
              <DataTableHeader :column="column" :lines="2" />
            </template>
            <template v-slot:[`header.spanType`]="{ column }">
              <DataTableHeader :column="column" :lines="2" />
            </template>
            <template v-slot:[`header.spanProtectSystem`]="{ column }">
              <DataTableHeader :column="column" :lines="2" />
            </template>
            <template v-slot:[`header.nstmGroupNumber`]="{ column }">
              <DataTableHeader :column="column" :lines="2" />
            </template>
            <template v-slot:item="{ item }">
              <tr>
                <td class="text-center">
                  {{
                    item?.spanConfigDesignation
                      ? configStore.getReferenceValue(
                          REFERENCE_TABLE.SPAN_CONFIG_DESIGNATION,
                          item?.spanConfigDesignation
                        )
                      : ""
                  }}
                </td>
                <td class="text-center">
                  {{
                    item?.mainSpanSetIndicator
                      ? configStore.getReferenceValue(
                          REFERENCE_TABLE.MAIN_SPANSET_INDICATOR,
                          item?.mainSpanSetIndicator
                        )
                      : ""
                  }}
                </td>
                <td class="text-center">
                  {{
                    item?.spanMaterial
                      ? configStore.getReferenceValue(REFERENCE_TABLE.SPAN_MATERIAL, item?.spanMaterial)
                      : ""
                  }}
                </td>
                <td class="text-center">
                  {{
                    item?.spanContinuity
                      ? configStore.getReferenceValue(REFERENCE_TABLE.SPAN_CONTINUITY, item?.spanContinuity)
                      : ""
                  }}
                </td>
                <td class="text-center">
                  {{ item?.spanType ? configStore.getReferenceValue(REFERENCE_TABLE.SPAN_TYPE, item?.spanType) : "" }}
                </td>
                <td class="text-center">
                  {{
                    item?.spanProtectSystem
                      ? configStore.getReferenceValue(REFERENCE_TABLE.SPAN_PROTECTION_SYSTEM, item?.spanProtectSystem)
                      : ""
                  }}
                </td>
                <td class="text-center">
                  {{ item.nstmGroupNumber }}
                </td>
              </tr>
            </template>
            <template v-slot:bottom> </template>
          </v-data-table>
          <v-data-table
            v-if="moduleType == MODULE_TYPES.MANAGEMENT"
            class="noScrollTable compactTable"
            :items-per-page="-1"
            :headers="headers"
            :items="spanSets"
            return-object
            hide-default-footer
          >
            <template v-slot:[`header.spanConfigDesignation`]="{ column }">
              <DataTableHeader :column="column" :lines="2" />
            </template>
            <template v-slot:[`header.mainSpanSetIndicator`]="{ column }">
              <DataTableHeader :column="column" :lines="2" />
            </template>
            <template v-slot:[`header.spanMaterial`]="{ column }">
              <DataTableHeader :column="column" :lines="2" />
            </template>
            <template v-slot:[`header.spanContinuity`]="{ column }">
              <DataTableHeader :column="column" :lines="2" />
            </template>
            <template v-slot:[`header.spanType`]="{ column }">
              <DataTableHeader :column="column" :lines="2" />
            </template>
            <template v-slot:[`header.spanProtectSystem`]="{ column }">
              <DataTableHeader :column="column" :lines="2" />
            </template>
            <template v-slot:[`header.nstmGroupNumber`]="{ column }">
              <DataTableHeader :column="column" :lines="2" />
            </template>
            <template v-slot:item="{ item }">
              <tr>
                <td class="text-center">
                  {{ item.spanConfigDesignation }}
                </td>
                <td class="text-center">
                  {{ configStore.getReferenceValue(REFERENCE_TABLE.MAIN_SPANSET_INDICATOR, item.mainSpanSetIndicator) }}
                </td>
                <td class="text-center">
                  {{ configStore.getReferenceValue(REFERENCE_TABLE.SPAN_MATERIAL, item.spanMaterial) }}
                </td>
                <td class="text-center">
                  {{ configStore.getReferenceValue(REFERENCE_TABLE.SPAN_CONTINUITY, item.spanContinuity) }}
                </td>
                <td class="text-center">
                  {{ configStore.getReferenceValue(REFERENCE_TABLE.SPAN_TYPE, item.spanType) }}
                </td>
                <td class="text-center">
                  {{ configStore.getReferenceValue(REFERENCE_TABLE.SPAN_PROTECTION_SYSTEM, item.spanProtectSystem) }}
                </td>
                <td class="text-center">
                  {{ item.nstmGroupNumber }}
                </td>
              </tr>
            </template>
            <template v-slot:bottom> </template>
          </v-data-table>
          <NSTMFatigueTable v-if="nstmFatigueValue" ref="nstmTable" :moduleType="moduleType" />
        </v-expansion-panel-text>
      </v-expansion-panel>
    </v-expansion-panels>
  </v-row>
</template>

<script>
import { computed, watch, ref, onMounted } from "vue";
import { useConfigStore } from "@/stores/config";
import { useInspectionStore } from "@/stores/inspection";
import { REFERENCE_TABLE } from "@/constants/ReferenceTables";
import NSTMFatigueTable from "@/components/shared/NSTMFatigueTable.vue";
import LabelSelect from "@/components/common/LabelSelect.vue";
import LabelText from "@/components/common/LabelText.vue";
import ExpandCollapseToggle from "@/components/shared/ExpandCollapseToggle.vue";
import { SNACKBAR_MARKER } from "@/constants/GlobalSnackbar.js";
import { useQuickSearchStore } from "@/stores/quickSearch";
import { MODULE_TYPES } from "@/constants/InspectionConstants";
import { storeToRefs } from "pinia";
import { useNstmStore } from "@/components/inspection/store/nstmFatigue";
import { useNstmDetailsStore } from "@/components/inspection/store/nstmFatigueDetails";
import { INSPECTION_STATUSES } from "@/constants/InspectionStatuses";
import { useUserPermissionStore } from "@/stores/userPermission";
import { INSPECTION_LINKS_PERMISSIONS } from "@/rbac";
import { ACCESS_LEVELS } from "@/rbac/accessLevels.js";
import { useInspectionLinksStore } from "@/stores/inspectionLinks";
import DataTableHeader from "@/components/common/DataTableHeader.vue";
import ValidationCountsHeader from "@/components/shared/ValidationCountsHeader.vue";
import { valueInLimitsRule } from "@/composables/validationRules";
export default {
  name: "InspectionNSTMFatigue",
  props: {
    moduleType: { default: MODULE_TYPES.INSPECTION },
  },
  setup(props) {
    let nstmConditionForm = ref(null);
    let validNSTMInspectionCondition = ref(true);
    let valid = ref(true);
    let nstmFatigueValue = ref({});
    let brkey = ref("");
    let inspectionId = ref("");
    let resetDirty = ref(false);
    let nstmStore = useNstmStore();
    let nstmFatigueDetailStore = useNstmDetailsStore();
    const structure = computed(() => inspectionStore.selectedInspection);
    const quickSearchStore = useQuickSearchStore();
    const structureHeader = computed(() => quickSearchStore.getStructure());
    const { hasQuickSearchSucceeded } = storeToRefs(quickSearchStore);
    const userPermissionStore = useUserPermissionStore();
    const inspectionLinksStore = useInspectionLinksStore();
    let spanSets = ref([]);
    let headers = [
      {
        line1: "B.SP.01",
        line2: "Span Config",
        line3: "Designation",
        key: "spanConfigDesignation",
        width: "5%",
        sortable: false,
      },
      {
        line1: "SP.02",
        line2: "Main Span ",
        line3: "Set Ind",
        key: "mainSpanSetIndicator",
        width: "5%",
        sortable: false,
      },
      {
        line1: "B.SP.04",
        line2: "Span Material",
        line3: "",
        title: " ",
        key: "spanMaterial",
        width: "7%",
        sortable: false,
      },
      {
        line1: "B.SP.05",
        line2: "Span",
        line3: "Continuity",
        key: "spanContinuity",
        width: "7%",
        sortable: false,
      },
      {
        line1: "B.SP.06",
        line2: "Span Type",
        line3: "",
        key: "spanType",
        width: "7%",
        sortable: false,
      },
      {
        line1: "B.SP.07",
        line2: "Span Prot.",
        line3: "System",
        key: "spanProtectSystem",
        width: "7%",
        sortable: false,
      },
      {
        line1: "SP.03",
        line2: "Group",
        line3: "",
        key: "nstmGroupNumber",
        width: "7%",
        sortable: false,
      },
    ];

    async function validate() {
      await nstmConditionForm.value.validate();
      if (validNSTMInspectionCondition.value) {
        valid.value = true;
      } else {
        valid.value = false;
      }
    }
    onMounted(async () => {
      await readData();
    });
    const allPanels = ["nstmConditions", "generalInformation", "nstmDetails"];
    const panels = ref(allPanels);
    const toggleAllPanels = (expandAll) => {
      if (expandAll) {
        panels.value = allPanels;
      } else {
        panels.value = [];
      }
    };

    const readData = async () => {
      nstmFatigueValue.value = {};
      resetDirty.value = true;
      brkey.value = "";
      inspectionId.value = "";
      if (props.moduleType == MODULE_TYPES.MANAGEMENT && structureHeader.value?.BRKEY) {
        if (!hasQuickSearchSucceeded.value) {
          resetDirty.value = true;
          return;
        }
        await nstmStore.loadDataObject(
          props.moduleType,
          structureHeader.value.BRKEY,
          structureHeader.value.INSPECTIONID
        );
      } else if (props.moduleType == MODULE_TYPES.INSPECTION) {
        brkey.value = structure.value.structureBridge.brkey;
        inspectionId.value = structure.value.inspection.inspectionId;
        await nstmStore.loadDataObject(props.moduleType, null, null, structure.value);
      }
      nstmFatigueValue.value = nstmStore.getNstmFatigue();
      spanSets.value = mapSpanSetFields(nstmFatigueValue?.value?.structureUnitSpanSets);
      nstmFatigueDetailStore.setNstmFatigueValue(nstmFatigueValue.value);
      resetDirty.value = true;
      await validate();
    };

    const saveChanges = async () => {
      const isSuccess = await nstmStore.saveData(props.moduleType, nstmFatigueValue.value, structure.value);
      if (isSuccess) {
        inspectionLinksStore.isDirty = false;
        if (props.moduleType == MODULE_TYPES.INSPECTION) {
          await nstmStore.loadDataObject(props.moduleType, null, null, structure.value);
        }
        nstmFatigueValue.value = nstmStore.getNstmFatigue();
        // Using this flag to not set the dirty flag in watch

        nstmFatigueDetailStore.setNstmFatigueValue(nstmFatigueValue.value);
        resetDirty.value = true;
      }
      return isSuccess;
    };

    const cancelChanges = async () => {
      //only called from Inspection Links
      nstmFatigueValue.value = nstmStore.getNstmFatigue();
      nstmFatigueDetailStore.setNstmFatigueValue(nstmFatigueValue.value);
      // Using this flag to not set the dirty flag in watch
      resetDirty.value = true;
      inspectionLinksStore.isDirty = false;
    };
    const isManagement = computed(() => props.moduleType == MODULE_TYPES.MANAGEMENT);

    const isEditable = computed(() => {
      if (props.moduleType == MODULE_TYPES.MANAGEMENT) {
        return quickSearchStore.hasQuickSearchSucceeded && nstmFatigueValue.value?.brkey && hasAccessToEdit.value;
      } else {
        return inspectionStore.isEditable;
      }
    });
    const hasAccessToEdit = computed({
      get() {
        if (structureHeader.value?.INSPECTIONSTATUS === INSPECTION_STATUSES.ACCEPTED) {
          return userPermissionStore.checkUserPermission(
            INSPECTION_LINKS_PERMISSIONS[ACCESS_LEVELS.CUSTOM.EDIT_APPROVED_INSPECTION],
            userPermissionStore.getUserPermissionByBrkeyFromCache(nstmFatigueValue.value.brkey)
          );
        } else {
          return userPermissionStore.checkUserPermission(
            INSPECTION_LINKS_PERMISSIONS[ACCESS_LEVELS.EDIT],
            userPermissionStore.getUserPermissionByBrkeyFromCache(nstmFatigueValue.value.brkey)
          );
        }
      },
    });

    const saveConditionFields = async () => {
      nstmFatigueValue.value.nstmCondition = nstmInspectionCondition.value;
    };
    const configStore = useConfigStore();
    const inspectionStore = useInspectionStore();
    function getNSTMInspectionCondition() {
      if (nstmFatigueValue.value?.mainFCGroupNum < 5 || nstmFatigueValue.value?.apprFCGroupNum < 5) {
        return nstmFatigueValue.value?.subProblemType;
      } else {
        return "N";
      }
    }

    const nstmInspectionCondition = computed({
      get() {
        if (!nstmFatigueValue.value.nstmCondition && !nstmInspectionConditionChangedByUser.value) {
          return getNSTMInspectionCondition();
        } else {
          return nstmFatigueValue.value?.nstmCondition;
        }
      },
      set(inspectionConditionParam) {
        nstmFatigueValue.value.nstmCondition = inspectionConditionParam;
      },
    });
    const superStructure = computed({
      get() {
        return nstmFatigueValue.value?.supProblemType;
      },
      set(value) {
        nstmFatigueValue.value.supProblemType = value;
      },
    });
    const subStructure = computed({
      get() {
        return nstmFatigueValue.value?.subProblemType;
      },
      set(value) {
        nstmFatigueValue.value.subProblemType = value;
      },
    });
    const estimatedTruckTraffic = computed({
      get() {
        return nstmFatigueValue.value?.estTruckTraffic;
      },
      set(value) {
        nstmFatigueValue.value.estTruckTraffic = value;
      },
    });
    const cumulativeTruckTrafficforFatigueDamage = computed({
      get() {
        return nstmFatigueValue.value?.estCumFatigLife;
      },
      set(value) {
        nstmFatigueValue.value.estCumFatigLife = value;
      },
    });
    const estimatedTruckYear = computed({
      get() {
        return nstmFatigueValue.value?.estTruckTrafficYear;
      },
      set(value) {
        nstmFatigueValue.value.estTruckTrafficYear = value;
      },
    });

    const mapSpanSetFields = (spans) => {
      if (!Array.isArray(spans)) return [];
      return spans
        .map((item) => ({
          spanConfigDesignation: item.spanConfigDesignation,
          mainSpanSetIndicator: item.mainSpanSetIndicator,
          spanMaterial: item.spanMaterial,
          spanContinuity: item.spanContinuity,
          spanType: item.spanType,
          spanProtectSystem: item.spanProtectSystem,
          nstmGroupNumber: item.nstmGroupNumber,
        }))
        .sort((a, b) => {
          const aIsM = a.spanConfigDesignation?.startsWith("M");
          const bIsM = b.spanConfigDesignation?.startsWith("M");

          if (aIsM && !bIsM) return -1; // M before A
          if (!aIsM && bIsM) return 1; // A after M

          // Extract numeric part for comparison
          const aNum = Number.parseInt(a.spanConfigDesignation?.slice(1), 10) || 0;
          const bNum = Number.parseInt(b.spanConfigDesignation?.slice(1), 10) || 0;

          return aNum - bNum;
        });
    };

    function fatigueChanged(newValue) {
      nstmFatigueDetailStore.setNstmFatigueValue(newValue);
    }

    const nstmInspectionConditionChangedByUser = computed(
      () => inspectionStore.getNstmInspectionConditionChangedByUser
    );

    let nstmTable = ref(null);

    const resetNSTMData = () => {
      nstmTable.value.getAllDetails();
    };

    const printD491 = () => {
      return { reportPage: "D491-Insp-NSTMFatigue-Screen", marker: SNACKBAR_MARKER.NSTM_FATIGUE };
    };

    // watch those objects used in component from structure to warn about unsaved changes
    watch(
      [nstmFatigueValue],
      () => {
        // This watch will NOT be triggered during initial onMounted()
        if (props.moduleType === MODULE_TYPES.MANAGEMENT) {
          // for management module
          if (resetDirty.value) {
            inspectionLinksStore.isDirty = false;
            resetDirty.value = false;
          } else {
            inspectionLinksStore.isDirty = true;
          }
        } else if (props.moduleType === MODULE_TYPES.INSPECTION) {
          // for inspection  module
          if (resetDirty.value) {
            inspectionStore.setDirtyFlag(false);
            resetDirty.value = false;
          } else {
            inspectionStore.setDirtyFlag(true);
          }
        }
      },
      { deep: true }
    );

    return {
      resetDirty,
      readData,
      estimatedTruckYear,
      nstmFatigueValue,
      cumulativeTruckTrafficforFatigueDamage,
      estimatedTruckTraffic,
      subStructure,
      superStructure,
      validate,
      valid,
      validNSTMInspectionCondition,
      nstmConditionForm,
      saveConditionFields,
      isEditable,
      panels,
      toggleAllPanels,
      nstmInspectionCondition,
      inspectionStore,
      REFERENCE_TABLE,
      configStore,
      structure,
      nstmTable,
      resetNSTMData,
      printD491,
      saveChanges,
      fatigueChanged,
      cancelChanges,
      spanSets,
      headers,
      MODULE_TYPES,
      isManagement,
      valueInLimitsRule,
    };
  },
  components: {
    LabelText,
    ExpandCollapseToggle,
    LabelSelect,
    NSTMFatigueTable,
    DataTableHeader,
    ValidationCountsHeader,
  },
};
</script>
<style scoped lang="scss">
@use "@/styles/general" as g;
@media #{"screen and (max-width: 1729px)"} {
  span {
    font-size: 12px !important;
    white-space: nowrap;
    overflow: hidden;
  }
}
@media #{"screen and (max-width: 1523px)"} {
  span {
    font-size: 10px !important;
    white-space: nowrap;
    overflow: hidden;
  }
}
.minHeight {
  @media #{g.$p-breakPointXlAndUp} {
    min-height: 1.5em !important;
    max-height: 1.5em !important;
  }
  @media #{g.$p-breakPointLgAndDown} {
    min-height: 1.4em !important;
    max-height: 1.4em !important;
  }
  @media #{"screen and (max-width: 1729px)"} {
    min-height: 1.3em !important;
    max-height: 1.3em !important;
  }
  @media #{"screen and (max-width: 1523px)"} {
    min-height: 1.2em !important;
    max-height: 1.2em !important;
  }
}
.v-table {
  th {
    text-align: center !important;
  }
  tr {
    text-align: center !important;
  }
}
.alignCenter {
  text-align: center !important;
}
</style>
